import React from "react";
import { Container } from "react-bootstrap";
import "./First.css";
import mainImg from "../../../../Asset/web-deployment.svg";
import { useNavigate } from "react-router-dom";

const First = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="First-mobileapp-section">
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
              <div className="hero-title">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    A Mobile App Development Company That{" "}
                    <strong className="text-skyblue">
                      Crafts Your Success
                    </strong>
                  </h1>
                  <div className="dec-text">
                    <p>
                      As your digital partner since 2010, we've enabled 150+
                      businesses to reach their success by building custom
                      mobile apps that engage users and add a competitive edge
                      to your business. Our proven track record comes from truly
                      understanding your mobile app development needs. Let's
                      work together to build the mobile app solutions that will
                      lead your business into the future.{" "}
                    </p>
                  </div>
                </div>
                <div className="hero-action-btn">
                  <p
                    className="btn btn-primary me-3"
                    onClick={() => {
                      navigate("/ContactUs");
                    }}
                  >
                    Free Consultation{" "}
                  </p>
                  <p
                    className="btn btn-primary-outline"
                    onClick={() => {
                      navigate("/portfolio");
                    }}
                  >
                    Success Stories{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobile-banner-img">
              <img alt="main" src={mainImg} className="w-100" />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
